import { BuilderContentData } from '~/src/common/services/Builder/types';
import { isBoolean, isString } from '~/src/common/utils/guards';

import Seo from './Seo';

interface Props {
  data: Nullable<BuilderContentData>;
}

const SeoCms = ({ data }: Props) => {
  if (data == null) return null;
  const { metaIndex, metaTitle, metaDescription, url } = data;

  return (
    <Seo
      canonicalUrl={isString(url) ? url : undefined}
      noIndex={isBoolean(metaIndex) ? !metaIndex : undefined}
      metaTitle={isString(metaTitle) ? metaTitle : undefined}
      metaDescr={isString(metaDescription) ? metaDescription : undefined}
      noSuffix
    />
  );
};

export default SeoCms;
